import * as React from 'react';

import Icon from 'components/icon';

import { wizardHero } from 'tempcontrol/enums';

interface WizardHeroProps {
  /**
   * Optional slot rendered to the right of the hero copy.
   * The Results page uses this for the "NEW PROJECT" CTA.
   */
  rightSlot?: React.ReactNode;
}

/**
 * Persistent hero rendered above every wizard step and the results page.
 * Mirrors the design's eyebrow + headline + body block on a light-sage
 * background with the dotted "pattern" overlay in the upper-right corner.
 */
export const WizardHero: React.VFC<WizardHeroProps> = ({ rightSlot }) => {
  return (
    <section className="c-block c-block--hero c-block--bg-light2 c-block--height-xs@xs">
      <div className="o-container-fluid">
        <div className="o-row u-flex-grow u-items-end">
          <div className="o-col-12 o-col-9@md">
            <div className="c-block__header u-mt-spacer-base">
              <p className="c-headline">{wizardHero.eyebrow}</p>
              <h1 className="c-title--extra-large">{wizardHero.title}</h1>
              <div className="c-hero__desc">
                <p>{wizardHero.body}</p>
              </div>
            </div>
          </div>
          {typeof rightSlot !== 'undefined' && (
            <div className="o-col-12 o-col-3@md u-flex u-justify-end u-items-end u-mb-spacer-base">{rightSlot}</div>
          )}
        </div>
      </div>
      <div className="c-block__pattern c-block__pattern--light3 c-block__overlay--opacity-40">
        <Icon name="pattern" className="o-svg-icon" />
      </div>
    </section>
  );
};

export default WizardHero;
